export type ImpoundStatus = 'ACTIVE' | 'RELEASED' | 'JUNKED' | 'SOLD';

/**
 * An impound's status in the words and colours the screens use: the pill
 * on the record and in the table, and the band over its group in the list,
 * all one colour, so the list and the record agree.
 *
 * One table for the phone and the dashboard. Each kept its own, and they
 * disagreed: the dashboard said "At Lot" and drew a lien sale in `info`, the
 * phone "At lot" and `processing`.
 */
export const IMPOUND_STATUS: Record<
  ImpoundStatus,
  {
    label: string;
    tone: 'warning' | 'success' | 'destructive' | 'processing';
  }
> = {
  ACTIVE: { label: 'At lot', tone: 'warning' },
  RELEASED: { label: 'Released', tone: 'success' },
  JUNKED: { label: 'Junked', tone: 'destructive' },
  SOLD: { label: 'Lien-sold', tone: 'processing' },
};

/**
 * A status the screens know, or At lot for one they do not. An own-property
 * check, as callStatusLabel's: a bare lookup of "constructor" walks the
 * prototype chain and returns a function.
 */
export const impoundStatus = (status: string) =>
  Object.prototype.hasOwnProperty.call(IMPOUND_STATUS, status)
    ? IMPOUND_STATUS[status as ImpoundStatus]
    : IMPOUND_STATUS.ACTIVE;
